import { axiosInstance as request } from '@api/rest.service'

const api = id => `/subscription-periods/${id}/evaluation`

/**
 * @description GET /subscription-periods/${id}/evaluation
 * @returns {AxiosPromise<any>}
 */
export const GET_SUBSCRIPTION_PERIOD_EVALUATION = id => request.get(api(id))

/**
 * @description PUT /subscription-periods/${id}/evaluation
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_SUBSCRIPTION_PERIOD_EVALUATION = (id, payload) => request.put(api(id), payload)
